function updateAttributes() {
  console.log("asdd");
  var url = window.location.href;
  $("cart-drawer-items .cart-items tbody tr").each(function (index) {
    index++;
    console.log(index);
    if (url.indexOf("/cart") > -1) {
      $(this).attr("id", "CartDrawer-Item-" + index);
      $(this)
        .find(".quantity__input")
        .attr("id", "Drawer-quantity-" + index);
      $(this).find(".quantity__input").attr("data-index", index);
      $("cart-items tr.cart-item:nth-child(" + index + ")").attr(
        "id",
        "CartItem-" + index
      );
      $("cart-items tr.cart-item:nth-child(" + index + ")")
        .find(".quantity__input")
        .attr("id", "Quantity-" + index);
      $("cart-items tr.cart-item:nth-child(" + index + ")")
        .find(".quantity__input")
        .attr("data-index", index);
      $("cart-items tr.cart-item:nth-child(" + index + ")")
        .find("cart-remove-button")
        .attr("id", "Remove-" + index);
      $("cart-items tr.cart-item:nth-child(" + index + ")")
        .find("cart-remove-button")
        .attr("data-index", index);
    } else {
      $(this).attr("id", "CartDrawer-Item-" + index);
      $(this)
        .find(".quantity__input")
        .attr("id", "Drawer-quantity-" + index);
      $(this).find(".quantity__input").attr("data-index", index);
    }
  });
}

function calculateProgress(currentVal, targetVal) {
  var valPrice1 = 99.0;
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var valPrice2 = $("#holiday-price").data("free-holiday");
  }
  // Now valPrice2 contains the value from settings.free_holiday
  console.log(valPrice2);
  var valPrice3 = 249.0;
  targetVal = valPrice1 * 100;
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    targetVal2 = valPrice2 * 100;
  }
  var progressBar = document.querySelectorAll(
    ".cart-shippingThreshold__progress"
  );
  var progressNum = document.querySelectorAll(".cart-shipping__num");
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var progressNumhol = document.querySelectorAll(".cart-shipping__num_hol");
  }
  var progressCont = document.querySelectorAll(".cart-shipping__cont");
  var progressOuter = document.querySelectorAll(".cart-shipping__numOuter");
  var progressAfter = document.querySelectorAll(".cart-shipping__numAfter");

  var successMsg = document.querySelectorAll(".cart-shipping__success");
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var holidayMsg = document.querySelectorAll(".gift_holiday");
  }
  // calculate how far progress is from the total as a percentage
  var result = Math.round((100 * currentVal) / targetVal);
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var result2 = Math.round((100 * currentVal) / targetVal2);
  }
  progressBar.forEach(function (el) {
    el.setAttribute("style", "width: ".concat(result, "%"));
  });
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    progressBar.forEach(function (el) {
      el.setAttribute("style", "width: ".concat(result2, "%"));
    });
  }
  // Update the progess text. If threshold is met, show success message
  var newProgressNum = (targetVal - currentVal) / 100;
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var newProgressNum2 = (targetVal2 - currentVal) / 100;
  }
  var New_currentVal = currentVal / 100;
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    if (New_currentVal >= valPrice2) {
      // Add product to the cart if the condition is met
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/cart.js",
        success: function (data) {
          const itemIdToCheck = $(".add-git-to-cart").data("gift");
          let itemExists = false;

          // Check if the item already exists in the cart
          for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].id == itemIdToCheck) {
              itemExists = true;
              break;
            }
          }

          // If the item does not exist, add it to the cart
          if (!itemExists) {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                quantity: 1,
                id: itemIdToCheck,
              },
              dataType: "json",
              success: function (response) {
                updateCartUI(); // Function to update cart UI
              },
              error: function (error) {
                console.log("Error adding product to cart", error);
              },
            });
          }
        },
        error: function (error) {
          console.log("Error fetching cart data", error);
        },
      });
    } else {
      // Remove product from the cart if the condition is not met
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/cart.js",
        success: function (data) {
          const itemIdToCheck = $(".add-git-to-cart").data("gift");
          let itemExists = false;

          // Check if the item exists in the cart
          for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].id == itemIdToCheck) {
              itemExists = true;
              break;
            }
          }

          // If the item exists, remove it from the cart
          if (itemExists) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: {
                quantity: 0,
                id: itemIdToCheck,
              },
              dataType: "json",
              success: function (response) {
                updateCartUI(); // Function to update cart UI
              },
              error: function (error) {
                console.log("Error removing product from cart", error);
              },
            });
          }
        },
        error: function (error) {
          console.log("Error fetching cart data", error);
        },
      });
    }

    function updateCartUI() {
      $.getJSON("/cart.js", function (data) {
        $(".cart-items tbody").empty(); // Clear existing cart items

        // Determine free shipping threshold and item id for gift card
        var freeshipprc = $("cart-drawer.drawer.animate.active").attr(
          "freeShipping"
        );
        var itemIdToChecks = $(".add-git-to-cart").data("gift");

        // Handle empty cart
        if (data.item_count === 0) {
          $(".emptyMsg").css("display", "block");
          $(".drawer").addClass("is-empty");
          $("cart-drawer-items").addClass("is-empty");
          $("#CartDrawer-CartItems").html(`
        <div class="drawer__cart-items-wrapper">
          <div class="top-cart-table">
            <table class="cart-items" role="table">
              <tbody role="rowgroup"></tbody>
            </table>
          </div>
        </div>
      `);
        } else {
          $(".emptyMsg").css("display", "none");
          $(".drawer").removeClass("is-empty");
          $("cart-drawer-items").removeClass("is-empty");

          // Loop through cart items
          $.each(data.items, function (index, item) {
            var itemId = index + 1;
            var isGiftCard = item.id == itemIdToChecks ? " giftCardMines" : "";

            // Append each item to the cart with the provided structure
            $(".cart-items tbody").append(`
          <tr id="CartDrawer-Item-${itemId}" class="cart-item${isGiftCard}" role="row">
            <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
              <a href="${
                item.url
              }" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>
              <img class="cart-item__image" src="${
                item.image
              }&width=300" alt="${item.product_title}" loading="lazy" width="150" height="150">
            </td>
            <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
              <p class="caption-with-letter-spacing light">PuraU</p>
              <a href="${
                item.url
              }" class="cart-item__name h4 break">${item.product_title}</a>
              <dl><div class="product-option">
                <dt>${item.options_with_values[0].name}:</dt>
                <dd>${item.options_with_values[0].value}</dd>
              </div></dl>
              <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
              <quantity-input class="quantity">
                <button class="quantity__button no-js-hidden" name="minus" type="button">
                  <span class="visually-hidden">Decrease quantity for ${
                    item.product_title
                  }</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                  </svg>
                </button>
                <input class="quantity__input" type="number" name="updates[]" value="${
                  item.quantity
                }" min="0" aria-label="Quantity for ${item.product_title}" id="Drawer-quantity-${itemId}" data-index="${itemId}">
                <button class="quantity__button no-js-hidden" name="plus" type="button">
                  <span class="visually-hidden">Increase quantity for ${
                    item.product_title
                  }</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                  </svg>
                </button>
              </quantity-input>
            </td>
            <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
              <div class="loading-overlay hidden">
                <div class="loading-overlay__spinner">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </div>
              <div class="cart-item__price-wrapper"><span class="price price--end">$${(
                item.original_price / 100
              ).toFixed(2)}</span></div>
            </td>
            <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
              <div class="cart-item__quantity-wrapper">
                <cart-remove-button id="CartDrawer-Remove-${itemId}" data-index="${itemId}">
                  <button class="button button--tertiary" aria-label="Remove ${
                    item.product_title
                  }">
                    Remove
                  </button>
                </cart-remove-button>
              </div>
            </td>
          </tr>
        `);
          });

          // Update total price and checkout button
          var totalPrice = (data.total_price / 100).toFixed(2);
          $("#CartDrawer-Checkout").html(`CHECKOUT - $${totalPrice} AUD`);
          $("#CartDrawer-Checkout").removeAttr("disabled");

          // Update cart count and other cart info
          $(".cart-count-bubble span").text(data.item_count);
          $("span.cart_count").text(data.brace);

          // Update free shipping progress and Afterpay price
          calculateProgress(data.total_price, freeshipprc);
          var afterpayPrice = (totalPrice / 4).toFixed(2);
          $(".afterpay").html("$" + afterpayPrice + " AUD");
        }

        $("body").removeClass("push-left-new");
        $(".title_upsell").addClass("hide");
        $(".mini-cart-product").remove();
        $("body").addClass("overflow-hidden");
        $("cart-drawer").addClass("animate active");

        // Update cart item IDs and attributes
        $(".cart-items tbody tr").each(function (index) {
          index++;
          $(this).attr("id", "CartDrawer-Item-" + index);
          $(this)
            .find(".quantity__input")
            .attr("id", "Drawer-quantity-" + index);
          $(this).find(".quantity__input").attr("data-index", index);
          $(this).find("cart-remove-button").attr("data-index", index);
        });
      });
    }
  }

  var cont1 = $(".cart-shipping_cont1").text();
  if ($("#cart-settings").data("enable-auto-gift") === "true") {
    var cont2 = $(".cart-shipping_cont2").text();
  }
  var cont3 = $(".cart-shipping_cont3").text();
  if (New_currentVal <= valPrice1) {
    var total_valPrice1 = (valPrice1 - New_currentVal).toFixed(2);
  } else if (New_currentVal <= valPrice2) {
    $(".cart-shipping__success").hide();
    $(".cart-shipping_cont1").addClass("free-active");
    var total_valPrice1 = (valPrice2 - New_currentVal).toFixed(2);
  } else {
    $(".gift_holiday").addClass("hide-it");
    $(".cart-shipping__success").show();

    $(".cart-shipping_cont1").addClass("free-active");
    if ($("#cart-settings").data("enable-auto-gift") === "true") {
      $(".cart-shipping_cont2").addClass("free-active");
    }
    var total_valPrice1 = (valPrice3 - New_currentVal).toFixed(2);
  }
  if (newProgressNum <= 0) {
    holidayMsg.forEach(function (el) {
      el.style.display = "block";
    });
    progressOuter.forEach(function (el) {
      el.style.display = "none";
    });
    progressAfter.forEach(function (el) {
      el.style.display = "none";
    });
    progressNum.forEach(function (el) {
      el.textContent = newProgressNum;
    });
    if ($("#cart-settings").data("enable-auto-gift") === "true") {
      progressNumhol.forEach(function (el) {
        el.textContent = newProgressNum2;
      });
    }
    if ($(".cart-item.giftCardMine").length) {
      $(".for-giftcard").addClass("hide");
    } else {
      if ($(".cart-item").length) {
        $(".drawer__footer").removeClass("hide");
        $(".for-giftcard").removeClass("hide");
      }
      var giftProId = $(".for-giftcard").attr("data-var-id");
      // if(giftProId != ''){
      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/add.js',
      //   data: {
      //     quantity: 1,
      //     id: giftProId
      //   },
      //   dataType: 'json',
      //   success: function(data) {
      //     $('.for-giftcard').addClass('hide');
      //     var idMine = $('.cart-items tbody tr').length;
      //     var itemIdToChecks = $('.add-git-to-cart').data('gift');
      //            var cc = '';
      //     if(data.id == itemIdToChecks){
      //       var cc = ' giftCardMines';
      //     }else{
      //        var cc = '';
      //     }
      //     if(idMine){
      //     idMine++;
      //     $('.cart-items tbody').prepend('<tr id="CartDrawer-Item-'+idMine+'" class="cart-item giftCardMine '+cc+'" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="'+data.url+'" class="cart-item__link" tabindex="-1" aria-hidden="true"></a><img class="cart-item__image" src="'+data.image+'&width=300" alt="'+data.product_title+'" loading="lazy" width="150" height="150"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><p class="caption-with-letter-spacing light">PuraU</p><a href="'+data.url+'" class="cart-item__name h4 break">'+data.product_title+'</a><dl><div class="product-option" dataMine="'+data.options_with_values[0].name+'"><dt>'+data.options_with_values[0].name+':</dt><dd>'+data.options_with_values[0].value+'</dd></div></dl><p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount"><svg aria-hidden="true focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>Gift Card Product</li></ul></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="cart-item__discounted-prices"><strong class="cart-item__final-price product-option">Free</strong></div><div class="cart-item__quantity-wrapper"><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="1" min="0" aria-label="Quantity for Inside &amp;amp; Out Gut Program" id="Drawer-quantity-'+idMine+'" data-index="'+idMine+'"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input></div><div id="CartDrawer-LineItemError-'+idMine+'" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div></td></tr>');
      //     }else{
      //     $('.drawer').removeClass('is-empty');
      //     $('cart-drawer-items').removeClass('is-empty');
      //     $('#CartDrawer-CartItems').html('<div class="drawer__cart-items-wrapper"><div class="top-cart-table"><table class="cart-items" role="table"><tbody role="rowgroup"><tr id="CartDrawer-Item-1" class="cart-item" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="'+data.url+'" class="cart-item__link" tabindex="-1" aria-hidden="true"></a><img class="cart-item__image" src="'+data.image+'&width=300" alt="'+data.product_title+'" loading="lazy" width="150" height="150"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><p class="caption-with-letter-spacing light">PuraU</p><a href="'+data.url+'" class="cart-item__name h4 break">'+data.product_title+'</a><dl><div class="product-option" dataMine="'+data.options_with_values[0].name+'"><dt>'+data.options_with_values[0].name+':</dt><dd>'+data.options_with_values[0].value+'</dd></div></dl><p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount"><svg aria-hidden="true focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>Gift Card Product</li></ul></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="cart-item__discounted-prices"><strong class="cart-item__final-price product-option">Free</strong></div><div class="cart-item__quantity-wrapper"><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="1" min="0" aria-label="Quantity for Inside &amp;amp; Out Gut Program" id="Drawer-quantity-1" data-index="1"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input></div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div></td></tr></tbody></table></div></div>');
      //     }
      //     $("body").removeClass("push-left-new");
      //     $(".title_upsell").addClass("hide");
      //     $('.cart-count-bubble span').text(data.item_count);
      //     $('span.cart_count').text(data.brace);
      //     $('.mini-cart-product').remove();
      //     fetch('/cart.js')
      //     .then(response => response.json())
      //     .then(data => {
      //       var minePrice = (data.total_price) / 100;
      //       $('.cart-drawer__footer .totals__subtotal-value').html('&nbsp;$'+minePrice+' AUD');
      //       setTimeout(function(){
      //         updateAttributes();
      //       }, 1000);
      //     });
      //   }
      // });
      // }
    }
  } else {
    var giftProId = $(".for-giftcard").attr("data-var-id");

    var a = "updates[" + giftProId + "]=0";
    if (giftProId != "") {
      // $.ajax({
      //   type: "POST",
      //   dataType: "json",
      //   url: "/cart/update.js",
      //   data: a,
      //   success: function(data) {
      //     if($('.cart-item').length){
      //       $('.drawer__footer').removeClass('hide');
      //       $('.for-giftcard').removeClass('hide');
      //     }
      //     $('.giftCardMine').remove();
      //     setTimeout(function(){
      //           updateAttributes();
      //         }, 1000);
      //   }
      // });
    }
    // holidayMsg.forEach(function(el){
    //   el.style.display = 'none';
    // });

    progressAfter.forEach(function (el) {
      el.style.display = "block";
    });
    progressNum.forEach(function (el) {
      el.textContent = total_valPrice1;
    });
    if (New_currentVal <= valPrice1) {
      progressCont.forEach(function (el) {
        el.textContent = cont1;
      });
    } else if (New_currentVal <= valPrice2) {
      progressCont.forEach(function (el) {
        el.textContent = cont2;
      });
      $(".cart-shipping_cont1").addClass("free-active");
    } else if (New_currentVal <= 249.0) {
      progressCont.forEach(function (el) {
        el.textContent = cont3;
      });
      $(".cart-shipping_cont1").addClass("free-active");
      if ($("#cart-settings").data("enable-auto-gift") === "true") {
        $(".cart-shipping_cont2").addClass("free-active");
      }
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log("adasdasdasdasdasd");
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          /*formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );*/
          formData.append("sections_url", window.location.pathname);
          // this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            $.ajax({
              type: "POST",
              url: "/cart.js",
              dataType: "json",
              success: function (data) {
                var freeShipping = $("cart-drawer").attr("freeShipping");
                console.log(data);
                calculateProgress(data.total_price, 99);
              },
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
